import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PDFDocument } from 'pdf-lib';
import cataloguePdf from '../Assets/PrimeRehabIndustriesBrochure.pdf';
import './ProductInfo.css';

const getIconUrl = (iconStr, idx) => {
    switch (idx) {
        case 0: return 'https://primerehabindustries.in/Image/Product/ico1.png';
        case 1: return 'https://primerehabindustries.in/Image/Product/ico2.png';
        case 2: return 'https://primerehabindustries.in/Image/Product/ico3.png';
        case 3: return 'https://primerehabindustries.in/Image/Product/ico4.png';
        default: return 'https://primerehabindustries.in/Image/Product/ico4.png';
    }
};

const ProductInfo = ({ product }) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownloadProductCatalogue = async (e) => {
        e.preventDefault();
        try {
            setIsDownloading(true);

            // 1. Fetch the unified PDF array buffer
            const response = await fetch(cataloguePdf);
            const existingPdfBytes = await response.arrayBuffer();

            // 2. Load it into pdf-lib
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pageCount = pdfDoc.getPageCount();

            // 3. Create a new document to hold extracted pages
            const newPdfDoc = await PDFDocument.create();

            // 4. Determine which pages to extract. 
            // Unified PDF layout: Page 0 is Cover, Page 1 is Product 1, Page 2 is Product 2,
            // then others share 2 per page starting Page 3.
            let targetPage = product.catalogPage;
            if (!targetPage) {
                if (product.id <= 2) {
                    targetPage = product.id;
                } else {
                    targetPage = 2 + Math.ceil((product.id - 2) / 2);
                }
            }
            const targetPageIndex = Math.min(targetPage, pageCount - 1);
            
            // Build the list of pages to copy (always include cover at index 0)
            let pagesToCopy = [0]; 
            if (Array.isArray(product.catalogPages)) {
                product.catalogPages.forEach(p => {
                    if (p < pageCount) pagesToCopy.push(p);
                });
            } else {
                pagesToCopy.push(targetPageIndex);
            }

            // Remove duplicates and sort
            pagesToCopy = [...new Set(pagesToCopy)].sort((a, b) => a - b);

            // Copy selected pages
            const copiedPages = await newPdfDoc.copyPages(pdfDoc, pagesToCopy);
            copiedPages.forEach((page) => newPdfDoc.addPage(page));

            // 5. Save the new PDF to bytes
            const pdfBytes = await newPdfDoc.save();

            // 6. Trigger download
            const blob = new Blob([pdfBytes], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `${product.title.replace(/\s+/g, '_')}_Catalogue.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error generating custom PDF:", error);
            // Fallback: download the whole brochure if extraction fails
            const link = document.createElement("a");
            link.href = cataloguePdf;
            link.download = `PrimeRehab_${product.title.replace(/\s+/g, '_')}_Brochure.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <section className="product-info-section">

            <div className="product-info-header">
                <span className="product-category-subtitle">{product.category}</span>
                <h1 className="product-detail-title">{product.title}</h1>
            </div>
            <div className="product-info-top">
                <div className="product-info-left">
                    <div className="product-main-image-wrapper">
                        <img src={product.image} alt={product.title} className="product-main-image" />
                    </div>
                </div>

                <div className="product-info-right">
                    <p className="product-main-desc">{product.description}</p>

                    <h3 className="key-features-title">Key Features</h3>
                    <ul className="key-features-list">
                        {(product.keyFeatures || []).map((feature, idx) => (
                            <li key={idx}>{feature}</li>
                        ))}
                    </ul>

                    <div className="product-action-buttons">
                        <Link to="/contact#contact-form" className="btn-enquire" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>ENQUIRE NOW</Link>
                        <button
                            onClick={handleDownloadProductCatalogue}
                            disabled={isDownloading}
                            className="btn-download-cat"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            {isDownloading ? 'GENERATING PDF...' : 'DOWNLOAD CATALOGUE'}
                        </button>
                    </div>
                </div>
            </div>

            <div className="product-specs-gallery-wrapper">
                {product.detailedSpecs && product.detailedSpecs.length > 0 && (
                    <div className="product-specs-container1">
                        <div className="detailed-specs-row">
                            {product.detailedSpecs.map((spec, idx) => (
                                <div className="detailed-spec-item" key={idx}>
                                    <div className="detailed-spec-icon">
                                        <img src={getIconUrl(spec.icon, idx)} alt={spec.label} className="spec-icon-img" />
                                    </div>
                                    <div className="detailed-spec-text">
                                        <span className="detailed-spec-label">{spec.label}</span>
                                        <span className="detailed-spec-value">{spec.value}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="product-gallery-grid">
                    {product.gallery.map((imgSrc, idx) => (
                        <div className="gallery-thumbnail" key={idx}>
                            {/* You can change these default gallery images in data/products.js */}
                            <img src={imgSrc} alt={`${product.title} view ${idx + 1}`} />
                        </div>
                    ))}
                </div>
            </div>

        </section>
    );
};

export default ProductInfo;
